import { SxProps } from '@mui/material';

export type ThemeIconPair = {
  default: string;
  hover: string;
};

const roundIconButtonBaseSx = {
  height: '44px',
  width: '44px',
  minWidth: '44px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'transparent',
  border: 'none',
  transition: 'all 0.2s ease-in-out',
};

export const ghostActionIconButtonSx = (icon: ThemeIconPair): SxProps => ({
  ...roundIconButtonBaseSx,
  backgroundImage: `url(${icon.default})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '24px 24px',
  '&:hover': {
    backgroundColor: 'action.hover',
    backgroundImage: `url(${icon.hover})`,
  },
  '&:disabled': {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
});

export const driveIconButtonSx = (color: string, hoverColor: string): SxProps => ({
  ...roundIconButtonBaseSx,
  color,
  '&:hover': {
    backgroundColor: 'action.hover',
    color: hoverColor,
  },
});
